import { http } from '@/core/helpers/axiosHelper';
import { Favorite } from './favorite.interface';
export class FavoriteService {
   async getFavorites() {
      throw Error('Method not implemented');
   }

   async getFavorite() {
      throw Error('Method not implemented');
   }

   async postFavorite(body: Favorite) {
      const response = await http.post<Favorite>('/favorite', body);
      return response.data;
   }

   async putFavorite() {
      throw Error('Method not implemented');
   }

   async deleteFavorite(favoriteId: number) {
      const response = await http.delete(`/favorite/${favoriteId}`);
      return response.data;
   }
}
